import React, { useMemo } from 'react';
import { TABLE_DEFAULT_DISPLAY } from '@/constants/config';
import { Cell } from '@/components/Bicester/Table/Cells';
import DatePicker from '@/components/shared/DatePicker';
import { isBefore, endOfDay, subMinutes } from 'date-fns';
import dayjs from 'dayjs';
import { BICESTER_FULL_DATE_HOURS_MINUTES } from '@/constants/dateFormat';
import { onChangeRowData } from '../utils';

// 生效时间
export const EffectiveTimeCell = ({ rowData, dataKey, setState, ...props }: any) => {
  const { isEdit, start_time, end_time } = rowData;

  const time = useMemo(() => {
    if (!start_time && !end_time) {
      return TABLE_DEFAULT_DISPLAY;
    }
    return `${dayjs(start_time).format(BICESTER_FULL_DATE_HOURS_MINUTES)} - ${dayjs(
      end_time
    ).format(BICESTER_FULL_DATE_HOURS_MINUTES)}`;
  }, [start_time, end_time]);

  return (
    <Cell {...props}>
      {isEdit ? (
        <div className="flex">
          <DatePicker
            value={dayjs(start_time).toDate()}
            className="edit-table-date-picker"
            onChange={(val) => {
              onChangeRowData(rowData?.id, { start_time: val }, setState);
              onChangeRowData(
                rowData?.id,
                {
                  end_time: dayjs(endOfDay(new Date(val))).format(BICESTER_FULL_DATE_HOURS_MINUTES),
                },
                setState
              );
            }}
            disabledDate={(date) => isBefore(date, subMinutes(new Date(), 1))}
            style={{ width: 170 }}
            cleanable={false}
            placement="topStart"
          />
          <span className="mx-[5px]">~</span>
          <DatePicker
            value={dayjs(end_time).toDate()}
            className="edit-table-date-picker"
            style={{ width: 170 }}
            onChange={(val) => onChangeRowData(rowData?.id, { end_time: val }, setState)}
            disabledDate={(date) =>
              isBefore(date, start_time ? new Date(start_time) : subMinutes(new Date(), 1))
            }
            cleanable={false}
            placement="topStart"
          />
        </div>
      ) : (
        time
      )}
    </Cell>
  );
};
